import {operationKey} from '../domain/campaignLiveOverlay';

export function buildInitialSchedulingItemsFromArts(arts = []) {
  if (!Array.isArray(arts) || arts.length === 0) {
    return [];
  }

  return arts.map((art, index) => {
    const pieceNumber = art?.piece_number ?? art?.pieceNumber ?? index + 1;
    const pieceName =
      art?.piece_name ||
      art?.pieceName ||
      `Post ${pieceNumber}`;

    return {
      pieceNumber,
      pieceName,
      status:
        art?.publicationId && art?.scheduleStatus === 'scheduled'
          ? 'scheduled'
          : 'pending',
      errorMessage: art?.errorMessage || null,
    };
  });
}

export function buildInitialSchedulingItemsFromSession(sessionDetail) {
  const scheduledArts = sessionDetail?.userInput?.scheduledArts;
  return buildInitialSchedulingItemsFromArts(scheduledArts);
}

export function resolveSchedulingLiveState(runtime) {
  const operation = runtime?.operation;
  if (operation?.family !== 'scheduling' || !operation?.trackingId) {
    return null;
  }

  const sessionId = runtime?.snapshot?.sessionId ?? runtime?.session?.id ?? null;
  const overlayKey = sessionId
    ? operationKey(sessionId, operation.trackingId)
    : null;
  const overlayOp = overlayKey
    ? runtime?.liveOverlay?.operations?.[overlayKey]
    : null;

  return {
    trackingId: operation.trackingId,
    items: Array.isArray(overlayOp?.schedulingItems)
      ? overlayOp.schedulingItems
      : null,
    summary: overlayOp?.summary ?? null,
    isRunning: operation.status === 'processing',
  };
}

export function resolveSchedulingProgressProps({
  part,
  schedulingLiveState = null,
  sessionDetail = null,
}) {
  const output = part?.output ?? {};
  const status = output.status;
  if (!['processing', 'completed', 'error'].includes(status)) {
    return null;
  }

  const trackingId = output.trackingId || part.toolCallId || null;
  const isActiveLive =
    schedulingLiveState?.trackingId &&
    trackingId &&
    schedulingLiveState.trackingId === trackingId;

  let items = Array.isArray(output.schedulingItems) ? output.schedulingItems : [];
  if (isActiveLive && Array.isArray(schedulingLiveState.items) && schedulingLiveState.items.length) {
    items = schedulingLiveState.items;
  } else if (status === 'processing' && items.length === 0) {
    items = buildInitialSchedulingItemsFromSession(sessionDetail);
  }

  const summary =
    isActiveLive && schedulingLiveState.summary
      ? schedulingLiveState.summary
      : output.summary || null;

  return {
    items,
    summary,
    isRunning: status === 'processing',
    errorMessage: status === 'error' ? output.message || null : null,
  };
}
